import { UseFormRegisterReturn } from 'react-hook-form'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import TextField, { FieldType, TextBoxSize } from '@/components/view/atoms/textfield/TextField'

export const FormTextFieldType = {
  DEFAULT: 'default',
  NUMBER: 'number',
  PRICE: 'price',
  PERCENT: 'percent',
  QUANTITY: 'quantity',
  POINT: 'point',
  TIMES: 'times',
  DAY: 'day',
  RADIO: 'radio',
  ADDRESS: 'address',
  PASSWORD: 'password',
  UNIT: 'unit',
  SHEET: 'sheet'
} as const

export type FormTextFieldType = (typeof FormTextFieldType)[keyof typeof FormTextFieldType]

interface Props {
  id?: string
  type?: FormTextFieldType
  fieldType?: FieldType
  size?: TextBoxSize
  register: UseFormRegisterReturn
  error?: boolean
  maxLength?: number
  placeholder?: string
  disabled?: boolean
  shrink0?: boolean
  label?: string
  suffix?: string
}

const FormTextField = ({
  id,
  type = FormTextFieldType.DEFAULT,
  fieldType = FieldType.DEFAULT,
  size = TextBoxSize.MEDIUM,
  register,
  error = false,
  maxLength = undefined,
  placeholder,
  disabled = false,
  shrink0 = false,
  label,
  suffix
}: Props) => {
  const isNumber =
    type == FormTextFieldType.NUMBER ||
    type == FormTextFieldType.PRICE ||
    type == FormTextFieldType.PERCENT ||
    type == FormTextFieldType.QUANTITY ||
    type == FormTextFieldType.POINT ||
    type == FormTextFieldType.TIMES ||
    type == FormTextFieldType.DAY ||
    type == FormTextFieldType.UNIT ||
    type == FormTextFieldType.SHEET
  return (
    <TextField
      id={id}
      fieldType={error ? FieldType.SEMI_REQUIRED : undefined} //fieldType}
      type={type == FormTextFieldType.PASSWORD ? 'password' : isNumber ? 'number' : 'text'}
      size={size}
      name={register.name}
      onChange={register.onChange}
      onBlur={register.onBlur}
      inputRef={register.ref}
      required={register.required}
      disabled={register.disabled || disabled}
      maxLength={register.maxLength || maxLength}
      minLength={register.minLength}
      min={register.min}
      max={register.max}
      pattern={register.pattern}
      prefix={
        type == FormTextFieldType.ADDRESS ? (
          '〒'
        ) : type == FormTextFieldType.PRICE ? (
          '¥'
        ) : type == FormTextFieldType.RADIO ? (
          <Icon type={IconType.RADIO_BUTTON} color={IconColor.DISABLED} />
        ) : undefined
      }
      suffix={
        type == FormTextFieldType.PERCENT
          ? '%'
          : type == FormTextFieldType.TIMES
            ? '回'
            : type == FormTextFieldType.DAY
              ? '日'
              : type == FormTextFieldType.QUANTITY
                ? '個'
                : type == FormTextFieldType.POINT
                  ? 'P'
                  : type == FormTextFieldType.UNIT
                    ? '点'
                    : type == FormTextFieldType.SHEET
                      ? '枚'
                      : (suffix ?? undefined)
      }
      error={error}
      placeholder={placeholder}
      shrink0={shrink0}
      label={label}
    />
  )
}

export default FormTextField
